<script setup lang="ts">
import { defineProps } from "vue";
import { Activity } from "@/types/calculators";

defineProps<{
  activity: Activity;
  isPositive: boolean;
}>();
</script>

<template>
  <div
    class="p-2.5 bg-white rounded-lg border border-divider flex items-center gap-2.5"
  >
    <span
      class="w-2 h-2 rounded-full shrink-0"
      :class="isPositive ? 'bg-success' : 'bg-error'"
    ></span>
    <div>
      <div class="text-xs font-bold text-brown">{{ activity.name }}</div>
      <div class="text-[11px] text-muted">{{ activity.ua }}</div>
    </div>
  </div>
</template>
